export function startTask(question, now = Date.now()) {
    return { status: 'running', question, startedAt: now, phase: 'preparing', tools: [], pendingCount: 0 };
}
export function startTaskTool(activity, tool, summary, now = Date.now(), meta) {
    if (activity.status !== 'running')
        return activity;
    const entry = { id: (activity.tools.at(-1)?.id ?? 0) + 1, tool, summary, status: 'running', startedAt: now, ...(meta?.connector ? { connector: meta.connector } : {}) };
    return { ...activity, tools: [...activity.tools, entry].slice(-100) };
}
export function finishTaskTool(activity, tool, ok, now = Date.now(), meta) {
    if (activity.status !== 'running')
        return activity;
    // The stream has no call IDs. The service executes calls sequentially; settle the oldest unmatched call.
    const index = activity.tools.findIndex(entry => entry.tool === tool && entry.status === 'running');
    if (index < 0)
        return activity;
    return {
        ...activity,
        tools: activity.tools.map((entry, i) => i !== index ? entry : {
            ...entry,
            status: ok ? 'success' : 'failure',
            finishedAt: now,
            // A connector on the result fills in a start that had none; a reason is kept only for a failure.
            ...(!entry.connector && meta?.connector ? { connector: meta.connector } : {}),
            ...(!ok && meta?.reason ? { reason: meta.reason } : {}),
            ...(meta?.connect ? { connect: meta.connect } : {}),
        }),
    };
}
export function interruptTask(activity, status, now = Date.now()) {
    if (activity.status !== 'running')
        return activity;
    return { ...activity, status, finishedAt: now, tools: activity.tools.map(entry => entry.status === 'running' ? { ...entry, status: 'interrupted', finishedAt: now } : entry) };
}
export function finishTask(activity, result, now = Date.now()) {
    if (activity.status !== 'running')
        return activity;
    let next = activity;
    // Auto actions use done.autoActions instead of a tool_result stream event.
    for (const action of result.autoActions ?? []) {
        if (!next.tools.some(entry => entry.tool === action.tool && entry.status === 'running')) {
            next = startTaskTool(next, action.tool, action.summary, now);
        }
        next = finishTaskTool(next, action.tool, action.result === 'success', now);
    }
    return reconcileTaskActions({
        ...next, finishedAt: now,
        status: result.mode !== 'ai' ? 'error' : 'complete',
        tools: next.tools.map(entry => entry.status === 'running' ? { ...entry, status: 'interrupted', finishedAt: now } : entry),
    }, result.pendingActions ?? []);
}
export function reconcileTaskActions(activity, actions) {
    if (['running', 'error', 'stopped'].includes(activity.status))
        return activity;
    const pending = actions.filter(action => !['done', 'failed', 'cancelled', 'expired'].includes(action.status ?? ''));
    const status = pending.some(action => action.status === 'reconciliation-required') ? 'reconciliation-required'
        : pending.some(action => action.status === 'executing' || action.status === 'confirmed') ? 'executing'
            : pending.length ? 'awaiting-approval' : actions.some(action => action.status === 'failed') ? 'error' : 'complete';
    return { ...activity, pendingCount: pending.length, status };
}
//# sourceMappingURL=taskActivity.js.map